// extracted by mini-css-extract-plugin
module.exports = {"bigProductionConst":"ProductionCost_bigProductionConst__1de-m"};